import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const Content: React.FC<EmptyProps> = () => {
	return (
		<div className="flex flex-col gap-2">
			<Text variant="heading" size="small" fontWeight="bold">
				<Translate value="corgi.app_download.bottom_banner_v2.headline" />
			</Text>
			<Text variant="body" size="medium">
				<Translate value="corgi.app_download.bottom_banner_v2.description" />
			</Text>
			<Text variant="body" size="medium" fontWeight="bold">
				<Translate value="corgi.app_download.bottom_banner_v2.ask" />
			</Text>
		</div>
	);
};
